<template>
  <div class="login">
    <form class="login-body" @submit.prevent="onSubmit">
      <div class="password-login">Masuk via kata sandi</div>
      <div class="input-block">
        <input
          v-model.trim="phone"
          type="tel"
          autofocus
          placeholder="Masukkan nomor handphone dengan awalan 08"
          maxlength="13"
        />
      </div>
      <div class="input-block">
        <input
          v-model.trim="password"
          maxlength="8"
          type="tel"
          class="password"
          placeholder="Masukkan 8 digit angka password"
        />
      </div>
      <span class="forget-password" @click="forgetPassword"
        >Lupa Password？</span
      >
      <button type="button" class="login-btn" @click="onSubmit">
        Login Password
      </button>
      <button type="button" class="SMS-btn" @click="goMessageLogin">
        Masuk dengan SMS
      </button>
      <button type="button" class="Daftar-btn" @click="goRegister">
        Daftar
      </button>
    </form>
  </div>
</template>

<script>
import { Toast } from 'vant'
import request from '@/utils/request'
import { validatePhoneNumber, validatePassword } from '@/utils/validator'
import { isIOS } from '@/utils/detect'
export default {
  name: 'Login',
  data () {
    return {
      phone: '',
      password: '',
      isIOS
    }
  },
  methods: {
    forgetPassword () {
      const { query } = this.$route
      this.$router.push({
        path: '/forgetPassword',
        query
      })
    },
    // 注册
    goRegister () {
      const { query } = this.$route
      this.$router.push({
        path: '/register',
        query
      })
    },
    validate () {
      const regex = /^(08|628)/
      if (!regex.test(this.phone)) {
        Toast('Masukkan nomor handphone dengan awalan 08')
        return false
      }
      if (!this.phone) {
        Toast('Masukkan nomor handphone dengan awalan 08')
        return false
      }
      if (!validatePhoneNumber(this.phone)) {
        Toast('Nomor handphone salah')
        return false
      }
      if (!this.password) {
        Toast('Masukkan 8 digit angka password')
        return false
      }
      if (!validatePassword(this.password)) {
        Toast('Password salah')
        return false
      }
      return true
    },
    onSubmit () {
      if (!this.validate()) return
      if (this.flag) return
      this.flag = true
      const postData = {
        lodrginType: 1,
        usdrerPhone: this.phone,
        usdrerPassword: this.password
      }
      const ixabisoelinye = sessionStorage.getItem('ixabisoelinye')
      if (ixabisoelinye) {
        postData.ixabisoelinye = ixabisoelinye
      }
      request.post('usdrerLogin', postData)
        .then(res => {
          this.$store.commit('recordInfo', {
            type: 'userInfo',
            value: res
          })
          localStorage.setItem('userInfo', JSON.stringify(res))
          this.addressBook()
          this.$router.push('/home1')
        })
        .finally(() => {
          this.flag = false
        })
    },
    goMessageLogin () {
      const { query } = this.$route
      this.$router.push({
        path: '/messageLogin',
        query
      })
    }

  }
}
</script>

<style scoped lang="less">
.login {
  display: flex;
  flex-direction: column;
  justify-content: end;
  padding: 0 34px;
}

.header-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 73px 30px 0;

  p {
    font-weight: 600;

    &:first-child {
      font-size: 40px;
      color: #4837bc;
    }

    &:last-child {
      font-size: 32px;
      color: #f9f9f9;
    }
  }
}

.title-block {
  display: flex;
  height: 88px;
  line-height: 88px;

  & > div {
    flex: 1;
    text-align: center;
  }
}

.password-login {
  font-size: 54px;
  font-weight: 600;
  color: #fff;
  margin-top: 150px;
  margin-bottom: 100px;
  text-align: center;
}

.message-login {
  border-radius: 10px;
  font-size: 28px;
  font-weight: 600;
  color: #fff;
  background-color: #ffc529;
}

.input-block {
  display: flex;
  align-items: center;
  height: 94px;
  background: #2e2f60;
  border-radius: 47px;

  &:nth-child(n + 2) {
    margin-top: 50px;
  }

  input {
    display: block;
    width: 100%;
    height: 88px;
    line-height: 88px;
    padding-left: 20px;
    border: none;
    border-radius: 10px;
    box-sizing: border-box;
    font-size: 30px;
    color: #fff;
    background: none;

    &::placeholder {
      color: #fff;
      font-size: 26px;
    }

    &:-webkit-autofill {
      transition: background-color 5000s ease-in-out 0s;
    }
  }
}

.password {
  -webkit-text-security: disc;
}

.forget-password {
  float: right;
  margin-bottom: 66px;
  margin-top: 30px;
  font-weight: 500;
  font-size: 32px;
  color: #ffffff;
}
.login-btn {
  .submit-btn;
  margin-top: 29px;
  background: #4bc4b3;
}
.SMS-btn {
  .cancel-btn;
  margin-top: 29px;
}

.footer {
  width: 358px;
  height: 85px;
  margin: 30px auto 25px;
}
.Daftar-btn {
  .cancel-btn;
  background: #069a5e;
  margin-top: 29px;
  color: #fff;
  width: 400px;
}
</style>
